import { Permission, usePermission } from '@bonusly/who-am-i';

export const useOneOnOnesAccess = () => {
	const canAccessOneOnOnes = usePermission(Permission.CanAccessOneOnOnes);

	return {
		canAccessOneOnOnes,
	};
};
